export default "__VITE_ASSET__n$IkjfrP__"